import { Injectable } from '@angular/core';
import { ErrorMessageResponse } from '@app/core/models/data-response';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({
    providedIn: 'root',
})
export class KpiCompService {
    constructor(private datatask: DataTaskService) {}

    /**
     * @datatask 3515
     * @datataskName sp_ws_p2_kpicomp_save
     * @param params the kpi comp to save,
     * @returns promise containing validation.
     */
    public async saveKpiComp(params: KpiCompGet): Promise<ErrorMessageResponse> {
        return (await this.datatask.Post(3515, params))[0];
    }

    /***
     * @datatask 3514
     * @datataskName sp_ws_p2_kpicomp_get
     * @param params keyno of the kpi comp to get.
     * @returns promise containing the kpi component setup.
     */
    public async getKpiComp(params: GetKpiCompParams): Promise<KpiCompGet> {
        const response = (await this.datatask.Post(3514, params))[0];
        let webpages;

        try {
            webpages = JSON.parse(response.webpages ?? '[]');
        } catch (error) {
            console.error(error);
            webpages = [];
        }

        return { ...response, webpages: webpages };
    }

    /**
     * @datatask 3521
     * @datataskName sp_ws_p2_kpicomp_type_list
     * @returns promise containing list of kpi component types.
     */
    public getKpiCompTypes(): Promise<KpiCompTypeItem[]> {
        return this.datatask.Post(3521);
    }

    /**
     * @datatask 3587
     * @datataskName sp_ws_p2_w_kpicomp_slicers_list
     * @param params the keyno of the kpi comp to get slicers for.
     * @returns promise containing list of kpi comp slicers.
     */
    public getKpiCompSlicers(params: GetKpiCompParams): Promise<KpiCompSlicerItem[]> {
        return this.datatask.Post(3587, params);
    }
}

export interface KpiCompSlicerItem {
    item_id: string;
    item_name: string;
    item_is_selected: '1' | '0';
    orderby: string;
}

export interface GetKpiCompParams {
    kpicomp_keyno: string;
}

export interface KpiCompGet {
    kpicomp_keyno: string;
    proc_name: string;
    reg_datetime: string;
    mod_datetime: string;
    is_public: '1' | '0';
    reg_by_portal_user_keyno: string;
    kpicomp_name_word_id: string;
    kpicomp_name: string;
    kpicomp_description_word_id: string;
    kpicomp_description: string;
    goto_item_state: string;
    goto_item_parms: string;
    item_glyphicon: string;
    item_glyphicon_color: string;
    tile_background_color: string;
    tile_heading_text: string;
    tile_heading_text_color: string;
    tile_subheading_text: string;
    tile_subheading_text_color: string;
    data1_text: string;
    p2_webpage_keyno: string;
    item_glyphicon_size: string;
    tile_subheading_text_size: string;
    tile_heading_text_size: string;
    kpicomp_type: string;
    tile_heading_text_word_id: string;
    tile_subheading_text_word_id: string;
    p2_datatask_keyno: string;
    webpages: { item_id: string; item_name: string }[];
}

export interface KpiCompTypeItem {
    color_id: string;
    color_name: string;
    orderby: string;
}
